import { ValidationAcumulator } from '../../components/interfaces';

const createValidationAcumulator = (): ValidationAcumulator => {
  let changed = false;
  let keys: string[] = [];
  let valid: { [key: string]: boolean | string } = {};

  const initialize = (...newKeys: string[]) => {
    changed = true;
    keys = newKeys;
    valid = {};
    keys.forEach((key) => {
      valid[key] = false;
    });
  };

  const hasKey = (key: string): boolean => {
    return keys.includes(key);
  };

  const isChanged = (): boolean => {
    return !!changed;
  };

  const acknowledgeChange = (): boolean => {
    if (changed) {
      changed = false;
      return true;
    }
    return false;
  };

  const isValid = (): boolean => {
    let result = true;
    keys.forEach((key) => {
      if (typeof valid[key] === 'string' || !valid[key]) {
        result = false;
      }
    });
    return result;
  };

  const setValid = (key: string, value: boolean | string) => {
    if (keys.includes(key)) {
      valid[key] = value;
    }
  };

  return {
    initialize,
    hasKey,
    isChanged,
    acknowledgeChange,
    isValid,
    setValid,
  };
};

export default createValidationAcumulator;